import * as constTemplate from '../constants/constants';

const defaultStore = {
  allTemplates: [],
  template: '',
  filterCategoryTemplates: '',
  pageCount: 0,
  currentPage: 1,
  searchNameTemplate: '',
  isLoadTemplates: false,
  errMessTemplates: '',
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'GET_ALL_TEMPLATES_SUCCESS':
      return {
        ...state,
        allTemplates: action.data.menus,
        pageCount: action.data.pages,
        isLoadTemplates: false,
        errMessTemplates: '',
      };

    case 'GET_ALL_TEMPLATES_ERROR':
      return {
        ...state,
        allTemplates: [],
        pageCount: 0,
        errMessTemplates: action.payload.message,
      };

    case 'GET_TEMPLATE_SUCCESS':
      return {
        ...state,
        template: action.data,
      };
    case 'FILTER_TEMPLATES_SUCCESS':
      return {
        ...state,
        allTemplates: action.data.menus,
      };

    case 'CLEAR_TEMPLATES_FILTER_LIST':
      return {
        ...state,
        filterCategoryTemplates: [],
      };
    case constTemplate.SET_SEARCH_TEMPLATE_NAME: {
      return {
        ...state,
        searchNameTemplate: action.payload.name,
      };
    }
    case constTemplate.SET_TEMPLATES_PAGINATION_PAGE: {
      return {
        ...state,
        currentPage: action.payload.numberPage,
      };
    }
    case constTemplate.TOGGLE_LOAD_TEMPLATES: {
      return {
        ...state,
        isLoadTemplates: true,
      };
    }
    case constTemplate.RESET_CHOOSED_TEMPLATE: {
      return {
        ...state,
        template: '',
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/template.js